import { render, staticRenderFns } from "./WeiRenZhengDetail.vue?vue&type=template&id=92750354&scoped=true"
import script from "./WeiRenZhengDetail.vue?vue&type=script&lang=js"
export * from "./WeiRenZhengDetail.vue?vue&type=script&lang=js"
import style0 from "./WeiRenZhengDetail.vue?vue&type=style&index=0&id=92750354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92750354",
  null
  
)

export default component.exports